import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddUserGroupComponent } from './add-user-group/add-user-group.component';
import { UpdateUserGroupComponent } from './update-user-group/update-user-group.component';
import { UserGroupDetailsComponent } from './user-group-details/user-group-details.component';

import { UserGroupPage } from './user-group.page';
import { UserGroupFilterComponent } from './user-group-filter/user-group-filter.component';
import { AddGroupFilterComponent } from './add-group-filter/add-group-filter.component';
import { UpdateGroupFilterComponent } from './update-group-filter/update-group-filter.component';
import { GroupFilterDetailsComponent } from './group-filter-details/group-filter-details.component';
import { BaseAppRouteGuardService } from 'src/app/core/services/base-app-route-guard.service';

const routes: Routes = [
  {
    path: '',
    component: UserGroupPage,
    canActivate: [BaseAppRouteGuardService],
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title:"user group"
    }
  },
  {
    path: 'add',
    component:  AddUserGroupComponent,
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title: "Add User Group"
    }
  },
  {
    path: 'update/:id',
    component:  UpdateUserGroupComponent,
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title: "Update User Group"
    }
  },
  {
    path: 'details/:id',
    component:  UserGroupDetailsComponent,
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title: "User Group Details"
    }
  },
  {
    path: 'group-filters/:id',
    component:  UserGroupFilterComponent,
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title: "User Group Filter Details"
    }
  },
  {
    path: 'add-filter/:id',
    component:  AddGroupFilterComponent,
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title: "Add User Group Filter"
    }
  },
  {
    path: 'update-filter/:id',
    component:  UpdateGroupFilterComponent,
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title: "Update User Group Filter"
    }
  },
  {
    path: 'filter-details/:id',
    component:  GroupFilterDetailsComponent,
    data : {
      Permission : 'ACCESS_VISUALIZATION',
      title: "Update User Group Filter"
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserGroupPageRoutingModule {}
